import React from 'react'
import Input from '../../Input/Input'
import Select from '../../Input/Select'
import Switch from '../../Input/Switch'
import ObjectListItem from '../ObjectListItem'
import Upload from '../../Input/Upload'
import { generateUploadFileSecureURI, startLoading, stopLoading } from '../../../services/common-service'
import axios from 'axios'
import BucketFile from '../../Input/BucketFile'
import TextList from '../TextList'

export default function FieldItem({
    data,
    setData,
    index,
    field,
    setValue
}) {
    const handleUploadChanged = async (key, files) => {
        try {
            startLoading()

            if (files.length == 0)
                throw { message: "Nenhum arquivo encontrado" }

            let uri = await generateUploadFileSecureURI(false)
            console.log("handleUploadChanged", uri)

            let file = files[0]
            let { type } = file

            let result = await axios.post(uri, file, { headers: { 'Content-Type': type } })
            // console.log(result)

            let link = result?.data?.mediaUri

            setValue(key, link)
        } catch (error) {
            console.error("caiu aqui")
            console.error(error)
        } finally {
            stopLoading()
        }
    }

    return (
        <div key={index}>
            {/* {JSON.stringify(data)} */}
            {/* {field.name} */}
            {field?.type == "text" &&
                <Input
                    name={field?.name}
                    label={field.label}
                    value={data[field?.name]}
                    onChange={e => setValue(field?.name, e.target.value)}
                    waitTime={50}
                />
            }

            {field?.type == "select" &&
                <Select
                    label={field.label}
                    options={field.options.map(option => ({
                        text: option.name,
                        value: option.value
                    }))}
                    value={data[field?.name]}
                    onChange={e => setValue(field?.name, e.target.value)}
                />
            }

            {field?.type == "object-list" &&
                <>
                    {/* {JSON.stringify(data)} - {field.name} */}
                    <ObjectListItem
                        label={field.label}
                        field={field}
                        // data={data[field?.name] || []}
                        data={data[field.name]}
                        setData={(newData) => {
                            setData(data => {
                                console.log("Data 1", JSON.stringify(data), field.name)
                                data[field.name] = newData(data[field.name] || [])
                                console.log("Data 2", JSON.stringify(data))
                                return { ...data }
                            })
                        }}
                    />
                </>
            }

            {field?.type == "switch" &&
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Switch
                        checked={data[field?.name] || false}
                        name={field?.name}
                        onChange={value => setValue(field?.name, value)}
                    />
                    <div style={{ marginLeft: 10 }}>
                        <bds-typo variant="fs-16" tag="h2" translate="" className="hydrated">{field.label}</bds-typo>
                        {/* - {data.active ? "true" : "false"} */}
                    </div>
                </div>
            }

            {field?.type == "file" &&
                <div>
                    <BucketFile
                        name={field?.name}
                        label={field.label}
                        value={data[field?.name]}
                        onChange={e => handleUploadChanged(field?.name, e.target.files)}
                        waitTime={50}
                    />
                </div>
            }

            {field?.type == "text-list" &&
                <div>
                    <TextList
                        label={field.label}
                        field={field}
                        data={data[field.name]}
                        setData={(newData) => {
                            setData(data => {
                                console.log("Data 1", JSON.stringify(data), field.name)
                                data[field.name] = newData(data[field.name] || [])
                                console.log("Data 2", JSON.stringify(data))
                                return { ...data }
                            })
                        }}
                    />
                </div>
            }
        </div>
    )
}